<template>
  <div class="hospital">
    <h3 class="hosbox">一般细菌培养及鉴定</h3>
    <div class="info hosbox" style="margin-top:0;">
      <div>
        就诊人：
        <span>{{ info.patientName }}</span>
      </div>
      <div v-if="info.visitId">
        病案号：
        <span>{{ info.visitId }}</span>
      </div>
      <div v-if="info.testId">
        报告单ID：
        <span>{{ info.testId }}</span>
      </div>
      <div>
        报告类型：
        <span>{{ info.bizTypeName }}</span>
      </div>
      <!-- <div>
                样本种类：
                <span>1111</span>
            </div>-->
      <div>
        科室：
        <span>{{ info.deptName }}</span>
      </div>
      <div>
        送检医生：
        <span>{{ info.applyDoctorName }}</span>
      </div>
      <div>
        申请时间：
        <span>{{ info.reqTime }}</span>
      </div>
      <!-- <div>
                报告时间：
                <span>1111</span>
            </div>-->
      <div>
        申请单号：
        <span>{{ info.testApplpId }}</span>
      </div>
    </div>
    <div class="diagnose hosbox">
      <div>
        临床诊断：
        <span class="fw">{{ info.lczd }}</span>
      </div>
    </div>

    <div class="examine">
      <p class="fw" style="font-size:30rpx;">检查结果</p>
      <div class="list">
        <div class="list_box" v-for="(i, index) in info.itemsList" :key="index">
          细菌名称：
          <span>{{ i.cultureName }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="result">
            <p class="fw" style="font-size:30rpx;">结果评价：</p>
            <div>铜绿假单胞菌对氨苄西林、头孢挫林天然耐药</div>
        </div>-->
  </div>
</template>

<script>
import { getCulture } from '@/api/report'
export default {
  data() {
    return {
      options: {},
      info: {},
    }
  },
  created() {
    this.option = this.$route.query
    this.init()
  },
  methods: {
    async init() {
      let res = await getCulture(this.option)
      if (res.code == 200) {
        this.info = res.data
        console.log(res.data, this.info)
      } else {
        this.info = {}
      }
    },
  },
}
</script>

<style lang="less" scoped>
.hospital {
  padding: 5px;
  display: flex;
  flex-direction: column;
  h3 {
    background: #fff;
    font-size: 20px;
    margin: 0;
    font-weight: 800;
  }
  p {
    margin: 0;
  }
  > div {
    display: flex;
    flex-wrap: wrap;
    background: #fff;
    box-shadow: 0 0 6px rgba(69, 157, 247, 0.19);
    border: 1px solid #f2f2f2;
    border-radius: 10px;
    margin-top: 15px;

    > div {
      font-size: 14px;
      > span {
        font-weight: 600;
      }
    }
  }
  .info {
    > div {
      width: 100%;
    }
  }
  .examine {
    padding: 15px 10px;
    flex-direction: column;
    flex-wrap: nowrap;
    .list {
      height: 0%;
      .list_box {
        padding: 10px 0;
        border-bottom: 1px solid #e5e5e5;
      }
      .list_box:last-child {
        padding-top: 10px;
        border: 0;
      }
    }
  }
  .result {
    flex-direction: column;
    flex-wrap: nowrap;
    flex: 1;
    padding: 15px 5px 20px;
  }
}
.hosbox {
  padding: 15px 10px;
}
.fw {
  font-weight: 800;
}
.pb {
  padding-bottom: 5px;
}
</style>
